/**
 * Shared constraint constants (EPIC-043).
 *
 * **Here rather than in `src/api/`** because both the server and the browser
 * need them, and a value import from `src/api/*` pulls the logger and drizzle
 * into the client bundle, where `process is not defined` blanks the whole app.
 * Type-only imports across that boundary are safe; values are not.
 *
 * This file replaces two independent copies of `DEPTH_THRESHOLD` — one in
 * `src/api/constraint-directory.ts`, one in `src/hooks/use-constraint-directory.ts`
 * — which had no import between them and could silently drift apart.
 */

/**
 * The rung at or above which someone counts as real depth on a constraint —
 * whether we could actually staff this, as opposed to merely having someone
 * who has heard of it.
 */
export const DEPTH_THRESHOLD = 4;
